import { render, staticRenderFns } from "./myHeader.vue?vue&type=template&id=12a744f5&scoped=true&"
import script from "./myHeader.vue?vue&type=script&lang=ts&"
export * from "./myHeader.vue?vue&type=script&lang=ts&"
import style0 from "./myHeader.vue?vue&type=style&index=0&id=12a744f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a744f5",
  null
  
)

export default component.exports